"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchStackQuery = exports.fetchStackEntry = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _polarisClientUtils = require("@noths/polaris-client-utils");
var _stackConfig = require("./stackConfig");
var CONTENTSTACK_TIMEOUT = 2000;
var getContentstackBaseURL = function getContentstackBaseURL(contentType) {
  return "https://cdn.contentstack.io/v3/content_types/".concat(contentType, "/entries");
};
var fetchFromContentstack = function fetchFromContentstack(env, stackName, baseUrl) {
  var url = (0, _polarisClientUtils.addParamsToHref)(baseUrl, {
    environment: _stackConfig.stackConfig[stackName].envs[env].name
  });
  var headers = {
    api_key: _stackConfig.stackConfig[stackName].apiKey,
    access_token: _stackConfig.stackConfig[stackName].envs[env].token
  };
  return (0, _polarisClientUtils.fetchJSONWithTimeout)(url, {
    headers,
    timeout: CONTENTSTACK_TIMEOUT
  });
};
var contentNotPublishedStatusCode = 422;
var fetchStackEntry = exports.fetchStackEntry = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(env, stackName, contentType, entryId) {
    var url, response, data;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = "".concat(getContentstackBaseURL(contentType), "/").concat(entryId);
          _context.prev = 1;
          _context.next = 4;
          return fetchFromContentstack(env, stackName, url);
        case 4:
          response = _context.sent;
          if (!(response.status === contentNotPublishedStatusCode)) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", null);
        case 7:
          if (response.ok) {
            _context.next = 9;
            break;
          }
          throw new Error("failed to get content by entry ID: url ".concat(url, " status:").concat(response.status));
        case 9:
          _context.next = 11;
          return response.json();
        case 11:
          data = _context.sent;
          return _context.abrupt("return", data.entry);
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 15]]);
  }));
  return function fetchStackEntry(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var fetchStackQuery = exports.fetchStackQuery = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(env, stackName, contentType, query) {
    var baseUrl, url, response, data;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          baseUrl = getContentstackBaseURL(contentType);
          url = (0, _polarisClientUtils.addParamsToHref)(baseUrl, {
            query: JSON.stringify(query)
          });
          _context2.prev = 2;
          _context2.next = 5;
          return fetchFromContentstack(env, stackName, url);
        case 5:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 8;
            break;
          }
          throw new Error("failed to get content by query: url ".concat(url, " status:").concat(response.status));
        case 8:
          _context2.next = 10;
          return response.json();
        case 10:
          data = _context2.sent;
          return _context2.abrupt("return", Array.isArray(data.entries) && data.entries[0] || null);
        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", Promise.reject(_context2.t0));
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 14]]);
  }));
  return function fetchStackQuery(_x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();